module.exports = require("create-react-class");